var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3279 15.2059L23.0609 20.9389L20.9389 23.0609L15.2059 17.3279C11.3811 20.0493 6.10892 19.3856 3.07801 15.8011C0.0471017 12.2165 0.268858 6.9074 3.58813 3.58813C6.9074 0.268858 12.2165 0.0471017 15.8011 3.07801C19.3856 6.10892 20.0493 11.3811 17.3279 15.2059ZM9.99986 2.99986C6.13387 2.99986 2.99986 6.13387 2.99986 9.99986C3.00427 13.864 6.13569 16.9955 9.99986 16.9999C13.8659 16.9999 16.9999 13.8659 16.9999 9.99986C16.9999 6.13387 13.8659 2.99986 9.99986 2.99986Z",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.fcbd5e59e1df06dbb19a0aa73237eb6b.svg";
export { ForwardRef as ReactComponent };